import { Clock, XCircle, CheckCircle2, Radio } from "lucide-react";

const STATUS_STYLES = {
    upcoming: "bg-blue-50 text-blue-700",
    confirmed: "bg-indigo-50 text-indigo-700",
    ongoing: "bg-emerald-50 text-emerald-700",
    completed: "bg-slate-100 text-slate-600",
    cancelled: "bg-rose-50 text-rose-600",
};

const STATUS_LABELS = {
    upcoming: "Upcoming",
    confirmed: "Confirmed",
    ongoing: "Live now",
    completed: "Completed",
    cancelled: "Cancelled",
};

export default function StatusBadge({ status }) {
    const label = STATUS_LABELS[status] || status.charAt(0).toUpperCase() + status.slice(1);
    return (
        <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium ${STATUS_STYLES[status] || "bg-slate-100 text-slate-600"}`}>
            {status === "completed" && <CheckCircle2 className="h-3 w-3" />}
            {status === "cancelled" && <XCircle className="h-3 w-3" />}
            {(status === "upcoming" || status === "confirmed") && <Clock className="h-3 w-3" />}
            {status === "ongoing" && <Radio className="h-3 w-3 animate-pulse" />}
            {label}
        </span>
    );
}